module.exports = __webpack_public_path__ + "media/packs/images/@privat/modal/icon-success-0d6c85cbfda0358fe6017270a026720e.png";